import { Button, OverlayTrigger, Popover, Table } from 'react-bootstrap';
var Link = require('react-router').Link;
var React = require('react');

var Address = require('../../util/Address');
var BillingActions = require('../../actions/BillingActions');
var BillingGroupStore = require('../../stores/BillingGroupStore');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var DateRange = require('../../util/DateRange');
var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var UserStore = require('../../stores/UserStore');
var ButtonLink = require('react-router-bootstrap').ButtonLink;

function getState() {
    return {
        groups: BillingGroupStore.get(),
        groupsLoading: BillingGroupStore.loading()
    }
}

var GroupTable = React.createClass({
    componentDidMount: function() {
        BillingGroupStore.addChangeListener(this.update);
        ClientStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        if (!ClientServiceStore.has() && !ClientServiceStore.loading()) {
            ServiceActions.getServices();
        }
    },
    componentWillUnmount: function () {
        BillingGroupStore.removeChangeListener(this.update);
        ClientStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return getState();
    },
    render: function () {
        const billingGroups = this.state.groupsLoading ?
            <Loading /> :
            this.state.groups.map(this.renderBillingGroupRow);

        return <section>
            <h2>Billing Groups</h2>

            <div className="row">
                <div className="col-md-6">
                    <p>
                        Billing groups are a way of keeping all your organisation's accounts
                        together but separating services/invoices into their own group to
                        allow us to send to a particular department, cost code or contact.
                        This can include separate Company name, ABN and terms. Below are the
                        current billing groups we have for your organisation, if you wish to
                        change, add or remove a billing group please contact us through the
                        {' '}<Link to="support">support page</Link>.
                    </p>
                </div>
            </div>

            <div className="row">
                {billingGroups}
            </div>
        </section>;
    },
    renderBillingGroupRow: function (billingGroup) {
        return <div className="col-md-4"><section className="powerwidget">
            <header><h2>{billingGroup.name}</h2></header>
            <div className="inner-spacer">
                {this.renderContact(billingGroup.contact)}
                <p>
                    <b>{Address.formatFromApi(billingGroup.site)}</b><br />
                    <small>{billingGroup.site.name}</small>
                </p>

                <ButtonLink bsStyle="primary" to="billing-group" params={{ billingGroupId: billingGroup.id }}>Manage Group</ButtonLink>
            </div>
        </section></div>;
    },
    renderContact: function (contact) {
        if (!contact) {
            return <p>No contact defined</p>;
        }

        return <p>
            <b>{contact.first_name} {contact.last_name}</b><br />
            <small>{contact.email}</small>
        </p>;
    },
    update: function() {
        this.setState(getState());
    }
})
module.exports = GroupTable;



// WEBPACK FOOTER //
// ./app/components/Accounting/GroupTable.js